import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import LoyaltyPanel from "../components/LoyaltyPanel";
import { apiErrorMessage } from "../services/api";
import { getCurrentUser } from "../services/authService";
import { fetchClient } from "../services/clientService";
import { can } from "../services/permissions";

/** Loyalty → Members → one member (`loyalty.view`): the card, rewards and ledger. */
export default function LoyaltyMember() {
  const { clientId } = useParams();
  const { t } = useTranslation();
  const [client, setClient] = useState(null);
  const [error, setError] = useState("");
  const mayOpenClient = can(getCurrentUser(), "clients.view");

  useEffect(() => {
    let cancelled = false;
    fetchClient(clientId)
      .then((data) => !cancelled && setClient(data))
      .catch((err) => !cancelled && setError(apiErrorMessage(err, t("loyalty.loadFailed"))));
    return () => {
      cancelled = true;
    };
  }, [clientId, t]);

  return (
    <div>
      <Link to="/loyalty/members" className="text-sm font-medium text-accent-text hover:underline">
        ← {t("loyalty.members.back")}
      </Link>

      <div className="mb-4 mt-3 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-xl font-bold">
            {client?.name ?? (error ? t("common.none") : t("common.loading"))}
          </h1>
          {client?.phone && (
            <p className="text-sm text-ink-2" dir="ltr">
              {client.phone}
            </p>
          )}
        </div>
        {client && mayOpenClient && (
          <Link to={`/clients/${client.id}`} className="btn-secondary">
            {t("loyalty.members.openClient")}
          </Link>
        )}
      </div>

      <LoyaltyPanel clientId={clientId} />
    </div>
  );
}
